import React from "react";
import { useParams } from "react-router-dom";

import ListGoals from "./ListGoals";
import GoalDetails from "./GoalDetails";
import TargetBuilderRoute from "./TargetBuilderRoute";
import TargetRouteSwitch from "./TargetRouteSwitch";

/**
 * Sub-router for the goals-targets section.
 * Determines which sub-view to render based on URL params:
 *   - /goals-targets                         → ListGoals
 *   - /goals-targets/:slug                   → GoalDetails
 *   - /goals-targets/:slug/target/new        → TargetBuilderRoute
 *   - /goals-targets/:slug/target/:subSlug   → TargetRouteSwitch (detail or edit)
 */
const GoalsAndTargetsRouter: React.FC = () => {
  const { slug, subSection, subSlug } = useParams<{
    slug?: string;
    subSection?: string;
    subSlug?: string;
  }>();

  if (subSection === "target" && subSlug === "new") {
    return <TargetBuilderRoute />;
  }

  if (subSection === "target" && subSlug) {
    return <TargetRouteSwitch />;
  }

  if (slug) {
    return <GoalDetails />;
  }

  return <ListGoals />;
};

export default GoalsAndTargetsRouter;
